<template>
  <div class="web-profile">
    <div class="img-box" v-loading="loading" v-if="list.length">
      <img
        v-for="item in list"
        :key="item.id"
        :src="item.url"
        class="profile-img"
        loading="lazy"
      />
    </div>
    <el-empty v-else-if="!loading" description="暂无内容" :image-size="100" />
  </div>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted, onBeforeUnmount } from "vue";
const { proxy } = getCurrentInstance();
const loading = ref(false);
const list = ref([]);

const portraitQuery = window.matchMedia("(orientation: portrait)");
const isPortrait = () => portraitQuery.matches || window.innerWidth < 768;

// 获取公司简介图片列表（type: 1=PC端 2=竖屏平板）
const getlist = async () => {
  const sendata = {
    type: isPortrait() ? 2 : 1,
  };
  try {
    loading.value = true;
    const res = await proxy.$api.shouye.getProfileList(sendata);
    if (res.data.code == 200) {
      const arr = res.data.data?.list || [];
      list.value = arr
        .sort((a, b) => a.sort - b.sort) //排序
        .map((item) => ({
          ...item,
          //后端不返回补上https
          url: item.url.startsWith("http") ? item.url : "https://" + item.url,
        }));
    }
  } catch (e) {
    console.log("获取公司简介失败");
  } finally {
    loading.value = false;
  }
};

// 监听横竖屏切换 窗口尺寸变化
let lastType = null;
const handleResize = () => {
  const type = isPortrait() ? 2 : 1;
  if (type !== lastType) {
    lastType = type;
    getlist();
  }
};

const onOrientationChange = () => {
  setTimeout(handleResize, 200);
};

onMounted(() => {
  handleResize();
  portraitQuery.addEventListener?.("change", onOrientationChange);
  window.addEventListener("resize", handleResize);
});

onBeforeUnmount(() => {
  portraitQuery.removeEventListener?.("change", onOrientationChange);
  window.removeEventListener("resize", handleResize);
});
</script>

<style lang="scss" scoped>
.web-profile {
  min-height: 300px;
  background: #fff;
  .img-box {
    .profile-img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
}
</style>
